// 全站统一的轻量 toast 提示，风格匹配站点棕金主题。
// 替代 element-ui 的 Message，调用方式保持兼容：
//   this.$message('xxx')                     -> info
//   this.$message({ message: 'xxx' })        -> info
//   this.$message({ message:'xxx', type:'success' })
//   this.$message.success('xxx')
//   this.$message.error({ message:'xxx' })
//   this.$message.warning(...)
//   this.$message.info(...)

const CONTAINER_ID = 'phb-message-container';
const STYLE_ID = 'phb-message-style';
const DEFAULT_DURATION = 2600;
const ANIM_MS = 260;

function ensureStyle() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.innerHTML = `
    #${CONTAINER_ID}{
      position:fixed;
      top:24px;
      left:50%;
      transform:translateX(-50%);
      z-index:9999;
      display:flex;
      flex-direction:column;
      align-items:center;
      pointer-events:none;
    }
    .phb-msg{
      pointer-events:auto;
      min-width:240px;
      max-width:520px;
      margin-bottom:12px;
      padding:12px 22px 12px 16px;
      display:flex;
      align-items:center;
      background:#fff;
      border-radius:8px;
      box-shadow:0 8px 24px rgba(125,77,54,0.18);
      font-family:"Microsoft YaHei","PingFang SC",sans-serif;
      font-size:14px;
      color:#3E2D20;
      border-left:4px solid #A37135;
      opacity:0;
      transform:translateY(-12px);
      transition:opacity ${ANIM_MS}ms ease, transform ${ANIM_MS}ms ease;
    }
    .phb-msg.phb-msg-show{
      opacity:1;
      transform:translateY(0);
    }
    .phb-msg-icon{
      width:22px;
      height:22px;
      flex-shrink:0;
      margin-right:10px;
      display:flex;
      align-items:center;
      justify-content:center;
    }
    .phb-msg-text{
      line-height:20px;
      word-break:break-all;
    }
    .phb-msg-close{
      margin-left:14px;
      width:16px;
      height:16px;
      display:flex;
      align-items:center;
      justify-content:center;
      cursor:pointer;
      color:#B89B70;
      font-size:14px;
      line-height:1;
      flex-shrink:0;
      border-radius:50%;
      transition:background .2s;
    }
    .phb-msg-close:hover{ background:#F6EFE2; color:#7D4D36; }

    /* 类型主题 */
    .phb-msg-success{ border-left-color:#7BA77A; }
    .phb-msg-success .phb-msg-icon{ color:#5E8C5C; }
    .phb-msg-error{ border-left-color:#C66A55; }
    .phb-msg-error .phb-msg-icon{ color:#B85A45; }
    .phb-msg-warning{ border-left-color:#D7A24B; }
    .phb-msg-warning .phb-msg-icon{ color:#B87E2A; }
    .phb-msg-info{ border-left-color:#A37135; }
    .phb-msg-info .phb-msg-icon{ color:#A37135; }
  `;
  document.head.appendChild(style);
}

function ensureContainer() {
  ensureStyle();
  let el = document.getElementById(CONTAINER_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = CONTAINER_ID;
    document.body.appendChild(el);
  }
  return el;
}

function iconSvg(type) {
  switch (type) {
    case 'success':
      return '<svg viewBox="0 0 22 22" width="22" height="22"><circle cx="11" cy="11" r="10" fill="currentColor" opacity="0.12"/><path d="M6 11.5l3.2 3.2L16 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    case 'error':
      return '<svg viewBox="0 0 22 22" width="22" height="22"><circle cx="11" cy="11" r="10" fill="currentColor" opacity="0.12"/><path d="M7 7l8 8M15 7l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    case 'warning':
      return '<svg viewBox="0 0 22 22" width="22" height="22"><circle cx="11" cy="11" r="10" fill="currentColor" opacity="0.12"/><path d="M11 6v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="11" cy="15.2" r="1.2" fill="currentColor"/></svg>';
    case 'info':
    default:
      return '<svg viewBox="0 0 22 22" width="22" height="22"><circle cx="11" cy="11" r="10" fill="currentColor" opacity="0.12"/><path d="M11 10v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="11" cy="7.2" r="1.2" fill="currentColor"/></svg>';
  }
}

function show(options) {
  if (typeof document === 'undefined') return { close() {} };

  const opts = typeof options === 'string' ? { message: options } : (options || {});
  const type = opts.type || 'info';
  const message = opts.message || '';
  const duration = typeof opts.duration === 'number' ? opts.duration : DEFAULT_DURATION;
  const showClose = !!opts.showClose;

  const container = ensureContainer();
  const node = document.createElement('div');
  node.className = `phb-msg phb-msg-${type}`;
  node.innerHTML =
    `<span class="phb-msg-icon">${iconSvg(type)}</span>` +
    `<span class="phb-msg-text"></span>` +
    (showClose ? `<span class="phb-msg-close">&times;</span>` : '');
  // 通过 textContent 防 XSS
  node.querySelector('.phb-msg-text').textContent = message;
  container.appendChild(node);

  // 强制回流以触发过渡
  // eslint-disable-next-line no-unused-expressions
  node.offsetHeight;
  node.classList.add('phb-msg-show');

  let closed = false;
  const close = () => {
    if (closed) return;
    closed = true;
    node.classList.remove('phb-msg-show');
    setTimeout(() => {
      if (node.parentNode) node.parentNode.removeChild(node);
    }, ANIM_MS);
  };

  if (duration > 0) {
    setTimeout(close, duration);
  }

  if (showClose) {
    const btn = node.querySelector('.phb-msg-close');
    if (btn) btn.addEventListener('click', close);
  }

  return { close };
}

function PhbMessage(options) {
  return show(options);
}

['success', 'warning', 'info', 'error'].forEach((t) => {
  PhbMessage[t] = (options) => {
    const opts = typeof options === 'string' ? { message: options } : (options || {});
    opts.type = t;
    return show(opts);
  };
});

PhbMessage.closeAll = function () {
  const container = document.getElementById(CONTAINER_ID);
  if (!container) return;
  const items = container.querySelectorAll('.phb-msg');
  items.forEach((n) => {
    n.classList.remove('phb-msg-show');
    setTimeout(() => {
      if (n.parentNode) n.parentNode.removeChild(n);
    }, ANIM_MS);
  });
};

export default PhbMessage;



// WEBPACK FOOTER //
// ./src/common/phbMessage.js